export const SPAWN_POSITION = [0, 0, 20];

export const CORRIDOR_BOUNDS = { minX: -17, maxX: 17, minZ: -114, maxZ: 24 };

export const PATH_POINTS = [
  [0, 0.06, 20],
  [-7, 0.06, 10],
  [0, 0.06, 0],
  [7, 0.06, -14],
  [0, 0.06, -26],
  [0, 0.06, -40],
  [-5, 0.06, -63],
  [9, 0.06, -76],
  [0, 0.06, -105],
];

export const POIS = [
  { id: "about", number: "01", label: "ABOUT", position: [-7, 0, 10], radius: 6 },
  { id: "experience", number: "02", label: "EXPERIENCE", position: [7, 0, -14], radius: 7 },
  { id: "projects", number: "03", label: "PROJECTS", position: [0, 0, -40], radius: 11 },
  { id: "skills", number: "04", label: "SKILLS", position: [-5, 0, -63], radius: 7 },
  { id: "education", number: "05", label: "EDUCATION", position: [9, 0, -76], radius: 6 },
  { id: "contact", number: "06", label: "SYSTEM ACCESS", position: [0, 0, -105], radius: 9 },
];

// Keep this open plaza clear of any procedural buildings so the 7 project
// pedestals never overlap building geometry (see buildingLayout.js exclusion).
export const PROJECTS_PLAZA_Z_RANGE = [-48, -32];

export function projectPedestalPosition(index, total) {
  const spread = 16;
  const x = -spread / 2 + (spread * index) / Math.max(total - 1, 1);
  return [x, 0, -40];
}
